import { API } from "aws-amplify";

export const resendEmailVerification = async (username: string) => {
  try {
    await API.post("signupapi", "/verify/resend", { body: { username } });
    return { success: true };
  } catch (err) {
    return { success: false, error: err };
  }
};
